/**
 * @generated SignedSource<<74c5da490e03b24b1b3e0e0d476fbbcf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountType",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNum",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountStatus",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactLastName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactFirstName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactEmail",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactPhone",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address1",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address2",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stripeCid",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dwollaCid",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activecampaignId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "achActive",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billingDayOfMonth",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxCharge",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "floatLimit",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "floatBalance",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useBudgets",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mccAuth",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mccWhitelist",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feeMonthly",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feeCustPercentage",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feeSelfPercentage",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plaidCheckPercAllow",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "achLimitNopeek",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "achLimitAbsolute",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "achPercAvailableOnCharge",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "achMinAvailableOnCharge",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ccPercAvailableOnCharge",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ccMinAvailableOnCharge",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v41 = [
  (v40/*: any*/)
],
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "WalletTsConnection",
  "kind": "LinkedField",
  "name": "walletTsByAccountId",
  "plural": false,
  "selections": (v41/*: any*/),
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feePlanName",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appId",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appName",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountTsConnection",
  "kind": "LinkedField",
  "name": "accountTsByParentId",
  "plural": false,
  "selections": (v41/*: any*/),
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psId",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psOrder",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "extSource",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "extPsId",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psType",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psStatus",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "BindCardTsConnection",
  "kind": "LinkedField",
  "name": "bindCardTsByProvisioningAccountId",
  "plural": false,
  "selections": (v41/*: any*/),
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerAppId",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentAppId",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bcId",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appStatus",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "extBcId",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bcStatus",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "atId",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "atCode",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "atSymbol",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "placement",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appSkuPrice",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appMarkupAbsolute",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appMarkupPercentage",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentOrder",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "marqetaMid",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oemAppId",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appUrl",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appLogo",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appSku",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appType",
  "storageKey": null
},
v77 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userName",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userRole",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "marqetaUid",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailVerified",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResellerLookupQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountT",
        "kind": "LinkedField",
        "name": "accountTByAccountId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v31/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          (v39/*: any*/),
          (v42/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FeePlanT",
            "kind": "LinkedField",
            "name": "feePlanTByFeePlanId",
            "plural": false,
            "selections": [
              (v43/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByParentId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AppTsConnection",
                "kind": "LinkedField",
                "name": "appTsByAccountId",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AppT",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v44/*: any*/),
                      (v45/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v46/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentSourceTsConnection",
            "kind": "LinkedField",
            "name": "paymentSourceTsByAccountId",
            "plural": false,
            "selections": [
              (v40/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PaymentSourceT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v47/*: any*/),
                  (v48/*: any*/),
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  (v52/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v53/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerAppTsConnection",
            "kind": "LinkedField",
            "name": "customerAppTsByCustomerAccountId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomerAppT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v44/*: any*/),
                  (v56/*: any*/),
                  (v57/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BindCardT",
                    "kind": "LinkedField",
                    "name": "bindCardTByBcId",
                    "plural": false,
                    "selections": [
                      (v49/*: any*/),
                      (v58/*: any*/),
                      (v59/*: any*/),
                      (v60/*: any*/),
                      (v61/*: any*/),
                      (v13/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v62/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AssetTypeT",
                    "kind": "LinkedField",
                    "name": "assetTypeTByAtId",
                    "plural": false,
                    "selections": [
                      (v63/*: any*/),
                      (v64/*: any*/),
                      (v65/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v66/*: any*/),
                  (v67/*: any*/),
                  (v68/*: any*/),
                  (v69/*: any*/),
                  (v70/*: any*/),
                  (v71/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AppT",
                    "kind": "LinkedField",
                    "name": "appTByAppId",
                    "plural": false,
                    "selections": [
                      (v55/*: any*/),
                      (v72/*: any*/),
                      (v73/*: any*/),
                      (v74/*: any*/),
                      (v45/*: any*/),
                      (v75/*: any*/),
                      (v76/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v77/*: any*/),
            "concreteType": "UserTsConnection",
            "kind": "LinkedField",
            "name": "userTsByAccountId",
            "plural": false,
            "selections": [
              (v40/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v78/*: any*/),
                  (v79/*: any*/),
                  (v80/*: any*/),
                  (v61/*: any*/),
                  (v60/*: any*/),
                  (v81/*: any*/),
                  (v82/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v83/*: any*/),
                  (v84/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "userTsByAccountId(first:20)"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResellerLookupQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountT",
        "kind": "LinkedField",
        "name": "accountTByAccountId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v31/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          (v39/*: any*/),
          (v42/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FeePlanT",
            "kind": "LinkedField",
            "name": "feePlanTByFeePlanId",
            "plural": false,
            "selections": [
              (v43/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v85/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByParentId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AppTsConnection",
                "kind": "LinkedField",
                "name": "appTsByAccountId",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AppT",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v85/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v85/*: any*/)
            ],
            "storageKey": null
          },
          (v46/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentSourceTsConnection",
            "kind": "LinkedField",
            "name": "paymentSourceTsByAccountId",
            "plural": false,
            "selections": [
              (v40/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PaymentSourceT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v47/*: any*/),
                  (v48/*: any*/),
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  (v52/*: any*/),
                  (v85/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v53/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerAppTsConnection",
            "kind": "LinkedField",
            "name": "customerAppTsByCustomerAccountId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomerAppT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v44/*: any*/),
                  (v56/*: any*/),
                  (v57/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BindCardT",
                    "kind": "LinkedField",
                    "name": "bindCardTByBcId",
                    "plural": false,
                    "selections": [
                      (v49/*: any*/),
                      (v58/*: any*/),
                      (v59/*: any*/),
                      (v60/*: any*/),
                      (v61/*: any*/),
                      (v13/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v85/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v62/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AssetTypeT",
                    "kind": "LinkedField",
                    "name": "assetTypeTByAtId",
                    "plural": false,
                    "selections": [
                      (v63/*: any*/),
                      (v64/*: any*/),
                      (v65/*: any*/),
                      (v85/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v66/*: any*/),
                  (v67/*: any*/),
                  (v68/*: any*/),
                  (v69/*: any*/),
                  (v70/*: any*/),
                  (v71/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AppT",
                    "kind": "LinkedField",
                    "name": "appTByAppId",
                    "plural": false,
                    "selections": [
                      (v55/*: any*/),
                      (v72/*: any*/),
                      (v73/*: any*/),
                      (v74/*: any*/),
                      (v45/*: any*/),
                      (v75/*: any*/),
                      (v76/*: any*/),
                      (v85/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v85/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v77/*: any*/),
            "concreteType": "UserTsConnection",
            "kind": "LinkedField",
            "name": "userTsByAccountId",
            "plural": false,
            "selections": [
              (v40/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v78/*: any*/),
                  (v79/*: any*/),
                  (v80/*: any*/),
                  (v61/*: any*/),
                  (v60/*: any*/),
                  (v81/*: any*/),
                  (v82/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v83/*: any*/),
                  (v84/*: any*/),
                  (v85/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "userTsByAccountId(first:20)"
          },
          (v85/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0e542469fd08c41ba4a6aa6313995321",
    "id": null,
    "metadata": {},
    "name": "ResellerLookupQuery",
    "operationKind": "query",
    "text": "query ResellerLookupQuery(\n  $accountId: UUID!\n) {\n  accountTByAccountId(accountId: $accountId) {\n    accountId\n    parentId\n    accountType\n    accountNum\n    accountName\n    description\n    accountStatus\n    contactLastName\n    contactFirstName\n    contactEmail\n    contactPhone\n    address1\n    address2\n    city\n    state\n    country\n    postalCode\n    stripeCid\n    dwollaCid\n    activecampaignId\n    achActive\n    billingDayOfMonth\n    maxCharge\n    floatLimit\n    floatBalance\n    useBudgets\n    mccAuth\n    mccWhitelist\n    feeMonthly\n    feeCustPercentage\n    feeSelfPercentage\n    plaidCheckPercAllow\n    achLimitNopeek\n    achLimitAbsolute\n    achPercAvailableOnCharge\n    achMinAvailableOnCharge\n    ccPercAvailableOnCharge\n    ccMinAvailableOnCharge\n    walletTsByAccountId {\n      totalCount\n    }\n    feePlanTByFeePlanId {\n      feePlanName\n      feeMonthly\n      feeCustPercentage\n      feeSelfPercentage\n      nodeId\n    }\n    accountTByParentId {\n      appTsByAccountId {\n        nodes {\n          appId\n          appName\n          nodeId\n        }\n      }\n      nodeId\n    }\n    accountTsByParentId {\n      totalCount\n    }\n    paymentSourceTsByAccountId {\n      totalCount\n      nodes {\n        psId\n        psOrder\n        extSource\n        extPsId\n        psType\n        psStatus\n        nodeId\n      }\n    }\n    bindCardTsByProvisioningAccountId {\n      totalCount\n    }\n    customerAppTsByCustomerAccountId {\n      nodes {\n        customerAppId\n        parentAppId\n        appId\n        bcId\n        appStatus\n        bindCardTByBcId {\n          extSource\n          extBcId\n          bcStatus\n          firstName\n          lastName\n          address1\n          city\n          state\n          country\n          postalCode\n          nodeId\n        }\n        atId\n        assetTypeTByAtId {\n          atCode\n          atSymbol\n          placement\n          nodeId\n        }\n        appSkuPrice\n        appMarkupAbsolute\n        appMarkupPercentage\n        notes\n        paymentOrder\n        marqetaMid\n        appTByAppId {\n          parentAppId\n          oemAppId\n          appUrl\n          appLogo\n          appName\n          appSku\n          appType\n          nodeId\n        }\n        nodeId\n      }\n    }\n    userTsByAccountId(first: 20) {\n      totalCount\n      nodes {\n        userId\n        userName\n        userRole\n        lastName\n        firstName\n        email\n        phone\n        address1\n        address2\n        city\n        state\n        country\n        postalCode\n        marqetaUid\n        emailVerified\n        nodeId\n      }\n    }\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "a924382c2c21aed0d1bf10ac3a787662";

module.exports = node;
